import { useCallback, useMemo, useState } from 'react';
import { ApiService, CompanyMeasurementDateName } from 'api';
import { useResponse } from 'services/hooks';
import { Logger } from 'utilities';

const useEnqueueIndividualCompanyReports = (
  enqueueToTrigger: Set<number>,
  firmId: number | null,
  selectedReportDate: CompanyMeasurementDateName | null,
  setEnqueueToTrigger: React.Dispatch<React.SetStateAction<Set<number>>>
) => {
  const { errorNotification } = useResponse();
  const [isLoading, setIsLoading] = useState(false);

  const enqueueButtonHandler = useCallback(async () => {
    setIsLoading(true);
    const payload = {
      company_measurement_dates: Array.from(enqueueToTrigger),
      firm: firmId!,
    };
    try {
      await ApiService.apiExcelExportsFullCompanyReportsByDateCreate(
        firmId!.toString(),
        selectedReportDate!.date,
        payload
      );
      setEnqueueToTrigger(new Set());
    } catch (error) {
      errorNotification('Error enqueuing individual company reports.');
      Logger.error('Error enqueuing individual company reports.', error);
    } finally {
      setIsLoading(false);
    }
  }, [enqueueToTrigger, firmId, selectedReportDate, errorNotification, setEnqueueToTrigger]);

  const enqueueButtonHandlerIsDisabled = useMemo(
    () => enqueueToTrigger.size === 0 || isLoading,
    [enqueueToTrigger, isLoading]
  );
  return { enqueueButtonHandler, isLoading, setIsLoading, enqueueButtonHandlerIsDisabled };
};
export default useEnqueueIndividualCompanyReports;
